import { createSlice } from "@reduxjs/toolkit";
// Начальное состояние
var initialState = {
    CreditRatingAgree: false,
};
// Слайс
var personalScoreSlice = createSlice({
    name: "personalScore",
    initialState: initialState,
    reducers: {
        setCreditRatingAgree: function (state, action) {
            state.CreditRatingAgree = action.payload;
        },
    },
});
// Экспортируем действия и редуктор
export var setCreditRatingAgree = personalScoreSlice.actions.setCreditRatingAgree;
export default personalScoreSlice.reducer;
